import { EMPTY_LIST } from '../../constants/common'
import Button from '../Button'

import PlusIcon from '../../icons/plus.svg'

export function getEmptyStateActions({
  Component = Button.Contained,
  Icon = PlusIcon,
  actionName,
  isLoading,
  qaName,
  shouldShowActions,
  text,
  onClick,
  ...buttonProps
}) {
  if (shouldShowActions) {
    return [
      {
        ...buttonProps,
        Component,
        beforeIconProps: { Icon },
        isSkeleton: isLoading,
        name: actionName,
        qaName,
        text,
        onClick,
      },
    ]
  }

  return EMPTY_LIST
}
